/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export interface Chargeback {
  chargebackDate: string;
  parentExternalTransactionId: string;
  parentOrderId: string;
  chargebackAmount: number;
  chargebackFee?: number;
  chargebackIssuer?: string;
  mfTransactionId?: string;
  status?: string;
  orderId?: string;
}
